
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class RowCustomizationGrid extends SiteEntityGrid<RowCustomizationRow, any> {
        protected getColumnsKey() { return 'Data.RowCustomization'; }
        protected getDialogType() { return RowCustomizationDialog; }
        protected getIdProperty() { return RowCustomizationRow.idProperty; }
        protected getLocalTextPrefix() { return RowCustomizationRow.localTextPrefix; }
        protected getService() { return RowCustomizationService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}